<template>
  <b-container fluid class="mt-4 px-3">
    <b-card>
      <!-- Header -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="6">
          <h3 class="mb-0">Listado de ventas</h3>
        </b-col>

        <b-col cols="6" class="text-right">
          <b-button variant="success" @click="goToNewSale">
            <b-icon icon="plus-circle" aria-hidden="true" class="mr-1" /> Nueva
            Venta
          </b-button>
        </b-col>
      </b-row>
      <!-- Tabla -->
      <b-row>
        <b-col>
          <b-table
            :items="pagedItems"
            :fields="fields"
            :busy="loading"
            small
            responsive="sm"
            hover
            striped
            stacked="md"
            show-empty
            @row-clicked="viewItem"
          >
            <template #cell(stock)="row">
              <b-badge :variant="stockVariant(row.item)">{{
                row.item.stock
              }}</b-badge>
              <small class="text-muted ml-2"
                >min: {{ row.item.stock_min }}</small
              >
            </template>

            <template #cell(price)="row">
              {{ formatCurrency(row.item.price) }}
            </template>

            <template #cell(total)="row">
              {{ formatCurrency(row.item.total) }}
            </template>

            <template #cell(category)="row">
              <span v-if="row.item.category">{{ row.item.category.name }}</span>
              <small v-else class="text-muted">-</small>
            </template>

            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="outline-primary"
                class="mr-1"
                @click.stop="show(row.item)"
              >
                <b-icon icon="eye" />
              </b-button>
            </template>

            <template #empty>
              <div class="text-center text-muted py-4">
                <div v-if="!loading">
                  <p class="mb-1">No hay artículos para mostrar.</p>
                  <small
                    >Podés crear uno nuevo o usar los datos de ejemplo para
                    probar la interfaz.</small
                  >
                </div>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- Paginación -->
      <b-row class="mt-3 align-items-center">
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="filteredItems.length"
            :per-page="perPage"
            align="left"
            size="sm"
          />
        </b-col>

        <b-col class="text-right">
          <small class="text-muted"
            >Página {{ currentPage }} / {{ totalPages }}</small
          >
        </b-col>
      </b-row>
    </b-card>
    <!-- Modal -->
    <b-modal
      id="modal-sale-detail"
      title="Detalle de la venta"
      size="xl"
      hide-footer
    >
      <b-table
        striped
        hover
        small
        :items="modalSale.line_sales"
        :fields="fieldsModal"
        responsive="sm"
      >
        <!-- Descripción del producto -->
        <template #cell(description)="data">
          {{ data.item.articulo.description }}
        </template>

        <!-- Cantidad -->
        <template #cell(quantity)="data">
          {{ data.item.quantity }}
        </template>

        <!-- Precio -->
        <template #cell(price)="data">
          $ {{ Number(data.item.price).toFixed(2) }}
        </template>

        <!-- Total por línea -->
        <template #cell(total)="data">
          $ {{ (data.item.quantity * data.item.price).toFixed(2) }}
        </template>
      </b-table>
      <div class="text-right mt-3 font-weight-bold">
        Total: $ {{ modalTotal }}
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import ArticleFormModal from "./ArticleFormModal.vue";
import VentaService from "@/services/venta.service";

export default {
  components: { ArticleFormModal },
  data() {
    return {
      q: "",
      filterCategory: null,
      perPage: 30,
      perPageOptions: [
        { value: 5, text: "5 por página" },
        { value: 8, text: "8 por página" },
        { value: 15, text: "15 por página" },
      ],
      currentPage: 1,
      fields: [
        { key: "id", label: "#", thStyle: { width: "50px" } },
        //{ key: "description", label: "DESCRIPCION", sortable: true , thStyle: { width: "220px" } },
        { key: "total", label: "TOTAL", thStyle: { width: "80px" } },
        { key: "day", label: "DIA", thStyle: { width: "80px" } },
        { key: "created_at", label: "FECHA", thStyle: { width: "80px" } },
        { key: "actions", label: "", thStyle: { width: "50px" } },
      ],
      selected: null,
      deleteTarget: null,
      deleting: false,
      categories: [],
      filteredItems: [],
      saleSelected: null,
      modalSale: {
        line_sales: [],
      },
      fieldsModal: [
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "price", label: "Precio" },
        { key: "total", label: "Total" },
      ],
    };
  },

  computed: {
    rawItems() {
      return this.$store.getters["articles/all"];
    },
    loading() {
      return this.$store.state.articles.loading;
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },
    itemsCountText() {
      return `${this.filteredItems.length} artículos`;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.perPage));
    },
    categoryFilterOptions() {
      return [{ value: null, text: "Todas las categorías" }].concat(
        this.categories.map((c) => ({ value: c.id, text: c.name }))
      );
    },
    modalTotal() {
      return this.modalSale.line_sales
        ?.reduce((sum, l) => sum + l.quantity * l.price, 0)
        .toFixed(2);
    },
  },

  methods: {
    goToNewSale() {
      this.$router.push({ name: "venta" });
    },
    applySearch() {
      this.currentPage = 1;
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "-";
      return (
        "$ " +
        Number(value).toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },
    stockVariant(item) {
      if (!item) return "secondary";
      return item.stock <= item.stock_min ? "danger" : "success";
    },
    show(item) {
      this.modalSale = item;
      this.$bvModal.show("modal-sale-detail");
    },
    viewItem(item) {
      this.$bvToast.toast(`${item.description} — Stock: ${item.stock}`, {
        title: `Articulo #${item.id}`,
        variant: "info",
        autoHideDelay: 3500,
      });
    },
    confirmDelete(item) {
      this.deleteTarget = item;
      this.$refs.confirmDeleteModal.show();
    },
    hideConfirm() {
      this.deleteTarget = null;
      this.$refs.confirmDeleteModal.hide();
    },
    async deleteItem() {
      if (!this.deleteTarget) return;
      this.deleting = true;
      try {
        await this.$store.dispatch("articles/delete", this.deleteTarget.id);
        this.$bvToast.toast("Artículo eliminado correctamente.", {
          title: "Eliminado",
          variant: "success",
          autoHideDelay: 2500,
        });
      } catch (err) {
        console.error(err);
        this.$bvToast.toast("No se pudo eliminar el artículo.", {
          title: "Error",
          variant: "danger",
          autoHideDelay: 3000,
        });
      } finally {
        this.deleting = false;
        this.hideConfirm();
      }
    },
    async fetchAll() {
      const res = await VentaService.getAll();
      this.filteredItems = res.data;
    },
    onSaved() {
      this.fetchAll();
      this.$bvToast.toast("Artículo guardado correctamente.", {
        title: "Guardado",
        variant: "success",
        autoHideDelay: 2000,
      });
    },
  },

  created() {
    this.fetchAll();
  },
};
</script>

<style scoped>
h3 {
  font-weight: 600;
}
</style>

